import styled from 'styled-components';
import {StyledSwitchContainer} from '../../../../atoms/Switch/styles';
import colors from '../../../../theme/constants/colors';
import Typography from '../../../../theme/typography';

export const StyledInputRow = styled.div`
  display: flex;
  flex-direction: row;

  > *:not(:last-child) {
    margin-right: 27px;
  }
`;

export const StyledErrorMsg = styled.div`
  > p {
    display: block;
    padding: 10px 15px;
    ${Typography.Body3}
    color: ${colors.red100};
    margin-top: 15px;
    background: ${colors.lightOrange};
    border-radius: 4px;
  }
`;

export const StyledSecondaryHeader = styled.h5`
  ${Typography.Body2}
  margin: 19px 0 13px;
`;

export const StyledPriceRange = styled.div`
  padding-bottom: 20px;
  border-bottom: 1px solid ${colors.grey25};
`;

export const StyledPriceBody = styled.div`
  > ${StyledSwitchContainer} {
    padding: 20px 0;
    border-bottom: 1px solid ${colors.grey25};

    &:last-child {
      padding-bottom: 0;
      border: none;
    }
  }
`;

const StyledPrice = styled.section`
  h4 {
    ${Typography.Subtitle1}
  }

  p {
    ${Typography.Body3}
  }
`;
export default StyledPrice;
